import { Component, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import {
  skipWhile,
  map,
  debounceTime,
  distinctUntilChanged,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState, PatientCartActionTypes } from '@app/core/ngrx';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'ecp-patient-cart-search',
  templateUrl: './patient-cart-search.component.html',
  styleUrls: ['./patient-cart-search.component.scss'],
})
export class PatientCartSearchComponent implements OnInit, OnDestroy {
  private searchSub$: Subscription;
  public search$: BehaviorSubject<any> = new BehaviorSubject(null);
  public form: FormGroup;
  constructor(private store: Store<AppState>, private fb: FormBuilder) {}
  ngOnInit() {
    this.form = this.createForm();
    this.searchSub$ = this.search$
      .pipe(
        skipWhile(event => !event),
        map(event => event.currentTarget.value),
        debounceTime(700),
        distinctUntilChanged(),
      )
      .subscribe(term => {
        this.store.dispatch({
          type: PatientCartActionTypes.LOAD_PATIENT_CART_SEARCH,
          payload: term,
        });
      });
  }

  ngOnDestroy(): void {
    if (this.searchSub$) this.searchSub$.unsubscribe();
  }

  /**createForm**/
  createForm(): FormGroup {
    return this.fb.group({
      searchText: [''],
    });
  }

  refreshCart() {
    this.store.dispatch({ type: PatientCartActionTypes.LOAD_PATIENT_CART });
    this.store.dispatch({
      type: PatientCartActionTypes.CLEAR_PATIENT_CART_SEARCH,
    });
    this.form.reset();
  }
}
